import { getColorFromString, getShade, Shade, Theme } from '@fluentui/react';

export const getHoverColor = (color: string, theme: Theme) =>
  getShade(getColorFromString(color)!, Shade.Shade7, theme.isInverted)!.str;
